import React from "react";

interface LoaderProps {
  loading: boolean;
}

const APILoader: React.FC<LoaderProps> = ({ loading }) => {
  if (!loading) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="p-6 bg-white rounded-lg shadow-lg">
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default APILoader;
